<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {
  queryVehicleExpenseTypes,
} from 'api/cost';
export default {
  components: {
    TableBox,
  },
  watch: {
    '$route.query.type': async function () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          this.$refs.searchBox.sub();
        }
      });
    },
    '$route.query.vehicleFeeType': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setFormAttrVal({
          form: this.searchBoxData,
          attr: 'hide',
          value: Number(newValue) === 3,
          names: ['vehicleFeeType'],
        });
        this.$refs.searchBox.sub();
      }
    },
  },
  data () {
    return {
      searchBoxData: {
        costTypesOptions: [], // 费用类型
        orgIdOptions: [], // 费用归属
        stateOptions: [], // 申请状态
        form: [
          { // 状态
            label: '状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择申请状态',
          },
          {
            label: '申请日期',
            value: 'Time',
            type: 'date',
            attr: {
              type: 'daterange',
            },
          },
          { // 费用类型
            label: '费用类型',
            value: 'costTypes',
            type: 'select',
            multiple: true,
            collapseTags: true,
            default: [''],
            placeholder: '请选择申请费用类型',
          },
          { // 报销类型
            label: '报销类型',
            value: 'vehicleFeeType',
            type: 'select',
            default: -1,
            placeholder: '请选择报销类型',
            options: [
              { label: '全部', value: -1 },
              { label: '车辆维护费用报销', value: 1 },
              { label: '订单费用报销', value: 2 },
              { label: '车辆费用申请', value: 3 },
            ],
            hide: true,
          },
          { // 申请金额
            label: '申请金额',
            value: 'Amt',
            type: 'inputrange',
            placeholder: '请输入申请金额',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 司机
            label: '司机',
            value: 'driverName',
            type: 'input',
            placeholder: '请输入司机',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time[0]) {
        searchBoxData.applyTimeBegin = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.applyTimeEnd = this.formatDate(searchBoxData.Time[1]);
      }
      delete searchBoxData.Time;
      // 申请金额
      if (searchBoxData.Amt && searchBoxData.Amt[0]) {
        searchBoxData.payAmtBegin = searchBoxData.Amt[0];
      }
      if (searchBoxData.Amt && searchBoxData.Amt[1]) {
        searchBoxData.payAmtEnd = searchBoxData.Amt[1];
      }
      delete searchBoxData.Amt;
      searchBoxData.costTypes = searchBoxData.costTypes.join(',');

      let isVehicleFeeTypeShow = false;
      this.$refs.tableBox.tableData.title = this.$refs.tableBox.reimbursementTitle;
      this.$refs.tableBox.title = '车辆费用报销明细记录';
      if (Number(this.$route.query.vehicleFeeType) === 3) {
        searchBoxData.vehicleFeeType = this.$route.query.vehicleFeeType;
        isVehicleFeeTypeShow = true;
        this.$refs.tableBox.tableData.title = this.$refs.tableBox.applyTitle;
        this.$refs.tableBox.title = '车辆费用申请明细记录';
      }
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'hide',
        value: isVehicleFeeTypeShow,
        names: ['vehicleFeeType'],
      });
      searchBoxData.waitDeal = true;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList(),
    ];
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_APPLY_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    let vehicleFeeType = 1;
    if (this.$route.query.type === 'apply') {
      vehicleFeeType = 3;
    }
    const costTypesOptions = await queryVehicleExpenseTypes({
      vehicleFeeType,
    });
    this.searchBoxData.costTypesOptions = [
      { label: '全部', value: '' },
      ...costTypesOptions,
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
